import notification from './notification.store'

export default {
    notification,
}